<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              v-if="item.index === 0"
              :headers="headers"
              :items="outs"
              item-value="CustCode"
              :search="search"
              :custom-filter="filterOnlyCapsText"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.CustCode }}</td>
                  <td>{{ item.CustName.toUpperCase() }}</td>
                  <td>{{ item.Amount | numberFormat }}</td>
                  <td>{{ item.Balance | numberFormat }}</td>
                  <td>{{ item.BilCount | numberFormat }}</td>
                  <td>{{ item.CustRoute }}</td>
                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="getoutsDetails(item.CustCode)"
                    >
                      View
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title>{{ dialogtitle }}</v-card-title>
          <v-card-text>
            <v-alert
              dismissible
              v-if="dialogerror"
              dense
              outlined
              type="error"
              >{{ dialogerror }}</v-alert
            >
          </v-card-text>
          <v-data-table
            :headers="dialogheaders"
            :items="selected"
            item-value="Doc_No"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.BillType }}</td>
                <td>{{ item.Doc_No }}</td>
                <td>{{ item.InvoiceDate }}</td>
                <td class="number">{{ item.Amount | numberFormat }}</td>
                <td class="number">{{ item.Balance | numberFormat }}</td>
                <td class="number">{{ item.PaidAmount | numberFormat }}</td>
                <td>{{ item.ChequeNo }}</td>
              </tr>
            </template>
            <template slot="body.append">
              <tr>
                <th colspan="3" class="number large">Totals</th>
                <th class="number large">{{ sumField("Amount") | numberFormat }}</th>
                <th class="number large">{{ sumField("Balance")  | numberFormat}}</th>
                <th class="number large">
                  {{ sumField("PaidAmount") | numberFormat }}
                </th>
              </tr>
            </template>
          </v-data-table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
/*
Address: ",,"
Creditlimit: 0
Disabled: false
Mobile: "0716814133"
RepCode: "S001"
RepName: "MR. PASAN KANCHUKA"
delete: false
userid: null
*/
import moment from "moment";
var numeral = require("numeral");
import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";
export default {
  data() {
    return {
      overlay: true,
      dialog: false,
      dialogtitle: "Outstanding details",
      dialogerror: null,
      search: "",
      name: "Outstandings",
      tabitems: [{ name: "All Outstandings", index: 0 }],
      rules: {
        required: (value) => !!value || "Required.",
      },
      tab: null,
      errormessage: null,
      outs: [],
      selected: [],
      dialogheaders: [
         {
          value: "BillType",
          text: "Bill Type",
          sortable: true,
        }, {
          value: "Doc_No",
          text: "Document No.",
          sortable: true,
        },
        {
          value: "InvoiceDate",
          text: "Invoice Date",
          sortable: true,
        },
      
        {
          value: "Amount",
          text: "Amount",
          sortable: true,
        },
        {
          value: "Balance",
          text: "Balance",
          sortable: true,
        },
        {
          value: "PaidAmount",
          text: "Paid",
          sortable: true,
        },
        {
          value: "ChequeNo",
          text: "Cheque No.",
          sortable: true,
        },
      ],
      headers: [
        {
          value: "CustCode",
          text: "Code",
          sortable: true,
        },
        {
          value: "CustName",
          text: "Name",
          sortable: true,
        },
        {
          value: "Amount",
          text: "Amount",
          sortable: true,
        },
        {
          value: "Balance",
          text: "Balance",
          sortable: true,
        },
        {
          value: "BilCount",
          text: "Bil Count",

          sortable: true,
        },
        {
          value: "CustRoute",
          text: "Route",
          sortable: true,
        },
        { value: "actions", text: "Actions" },
      ],
    };
  },
  filters: {
    toDate(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm");
      }
    },
    numberFormat(v) {
      //if (v) {
      return numeral(v).format("0,0.00");
      // }
    },
  },
  methods: {
    checkDel(item) {
      if (!item.Disabled || !item.delete) {
        return "deleted";
      } else return "";
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },
    sumField(key) {
      // sum data in give key (property)
      return this.selected.reduce((a, b) => a + (b[key] || 0), 0);
    },
     newRep() {
      //this.dialogtitle = "Add Rep";
      //this.dialog = true;
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },

    getouts() {
      HTTP.get(BASE_URL + "customers/outstanding/getall")
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.outs = response.data[0].dataset;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
      this.overlay = false;
    },
    getoutsDetails(code) {

      HTTP.get(BASE_URL + `customers/outstanding/one/` + code)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.selected = response.data[0].dataset;
      this.dialogtitle = "Outstandings : "+this.selected[0].CustName;

            console.log(this.selected);
          }
          this.dialog = true;
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },

    formaticon(v) {
      if (v) {
        return '<i class="mdi mdi-check green--text"></i>';
      } else {
        return '<i class="mdi mdi-window-close red--text"></i>';
      }
    },
  },

  mounted() {
    this.getouts();
  },
  beforeCreate() {
    console.clear();
    setAuthToken();
  },
};
</script>

<style scoped>
.v-application .mb-6 {
  margin-bottom: 0px !important;
}
</style>